import { HttpClient } from '@angular/common/http';
import { ISample } from '@app/core/model/samples/sample';
import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { DataTableUtilities } from '@app/core/utilities/data-table-utilities';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import {
  MATCHER_NAME_COLUMN_WIDTH_REDUCTION,
  OverrideColumnDefinition,
  OverrideColumnParameters
} from '@app/search/gridOptions/search-grid-options-formatter';
import { SampleSearchColumnFields, SampleSearchGridOptionsFormatter } from '@app/search/gridOptions/sample-search-grid-options-formatter';

export class SampleResourceMatcherGridOptionsFormatter extends SampleSearchGridOptionsFormatter {
  constructor(
    public resourceDictionaryService: SearchResourceDictionaryService,
    public bsshDatePipe: BsshDatePipe,
    public http: HttpClient
  ) {
    super(resourceDictionaryService, bsshDatePipe, http);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<SampleSearchColumnFields> {
    const inclusiveColumns: SampleSearchColumnFields[] = [
      SampleSearchColumnFields.Name,
      SampleSearchColumnFields.Project,
      SampleSearchColumnFields.Genome,
    ];

    const overrideColumnDefinitions: OverrideColumnDefinition<SampleSearchColumnFields>[] = [
      {
        colId: SampleSearchColumnFields.Name,
        cellRendererParams: (params) => {
          if (params.data && params.data.Sample) {
            const resource = this.resourceDictionaryService.getSearchResultResource(params.data, this.resourceType) as ISample;
            const sampleResourceConfig = this.resourceDictionaryService.getResourceConfigByType(this.resourceType);
            return DataTableUtilities.getRadLinkParams(
              resource.Name,
              sampleResourceConfig.uiHrefAccessor(params.data),
              this.getUnselectableRowMessage(params.node),
              null,
              MATCHER_NAME_COLUMN_WIDTH_REDUCTION
            );
          } else {
            return {};
          }
        }
      }
    ];

    return {
      inclusiveColumns,
      overrideColumnDefinitions
    };
  }
}

